import { getApplicationBackendUrl } from '../reducers/analyticsApp';
import { redirectToLogout } from '../utils/auth';

// Полноценный logout: уводим браузер на gateway /oauth/logout (RP-initiated logout) — шлюз
// редиректит на end-session Keycloak, тот гасит SSO-сессию и возвращает на /logout, где
// Micronaut очищает cookie JWT и уводит на настроенный logout-URL (корень analytics).
// Локального сброса state недостаточно — живая SSO-сессия молча перелогинит пользователя.
const logout = () => (dispatch, getState) => {
  redirectToLogout(getApplicationBackendUrl(getState()));
};

export default logout;
